<div class="main-content">
  <div class="container-fluid">
    <!-- Loading spinner -->
    <div *ngIf="isLoading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <!-- Client Details Section -->
    <div *ngIf="!isLoading && client" class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-primary">
            <div class="row">
              <div class="col-8">
                <h4 class="card-title mt-0">Client Details</h4>
                <p class="card-category">View and manage client information</p>
              </div>
              <div class="col-4 text-end">
                <button mat-raised-button type="button" class="btn btn-warning" (click)="editClient()">
                  <i class="material-icons">edit</i> Edit Client
                </button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <!-- Client Information -->
              <div class="col-md-6">
                <h5 class="text-primary mb-3">Client Information</h5>
                <div class="row mb-2">
                  <div class="col-md-4"><strong>ID:</strong></div>
                  <div class="col-md-8">{{ client?.id }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-4"><strong>Full Name:</strong></div>
                  <div class="col-md-8">{{ client?.fullName || '-' }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-4"><strong>Email:</strong></div>
                  <div class="col-md-8">{{ client?.email || '-' }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-4"><strong>Phone:</strong></div>
                  <div class="col-md-8">{{ client?.phoneNumber || '-' }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-4"><strong>Address:</strong></div>
                  <div class="col-md-8">{{ client?.address || '-' }}</div>
                </div>
              </div>
              <!-- Client Statistics -->
              <div class="col-md-6">
                <h5 class="text-primary mb-3">Client Statistics</h5>
                <div class="row mb-2">
                  <div class="col-md-4"><strong>Total Cases:</strong></div>
                  <div class="col-md-8">{{ client?.totalCases || 0 }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-4"><strong>Total Attachments:</strong></div>
                  <div class="col-md-8">{{ client?.totalAttachments || 0 }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-4"><strong>Total Expenses:</strong></div>
                  <div class="col-md-8">{{ client?.totalExpense || 0 | currency:'PKR ':'symbol':'1.2-2' }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-4"><strong>Total Amount:</strong></div>
                  <div class="col-md-8">{{ client?.totalAmount || 0 | currency:'PKR ':'symbol':'1.2-2' }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-4"><strong>Total Received:</strong></div>
                  <div class="col-md-8">{{ client?.totalReceived || 0 | currency:'PKR ':'symbol':'1.2-2' }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-4"><strong>Total Receivable:</strong></div>
                  <div class="col-md-8">{{ client?.totalReceivable || 0 | currency:'PKR ':'symbol':'1.2-2' }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabs Section -->
    <div *ngIf="!isLoading && client" class="row">
      <div class="col-md-12">
        <div class="card mt-0">
          <div class="card-body">
            <mat-tab-group 
            [selectedIndex]="selectedIndex" 
            (selectedTabChange)="onTabChange($event)">

              <!-- Cases Tab -->
              <mat-tab label="Cases">
                <div class="mt-3">
                  <!-- Add New Case Button -->
                  <div class="d-flex justify-content-end mb-3">
                    <button mat-raised-button type="button" class="btn btn-success" (click)="addNewCase()">
                      <i class="material-icons">add</i> Add New Case
                    </button>
                  </div>

                  <div *ngIf="casesLoading" class="text-center py-3">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading cases...</span>
                    </div>
                  </div>

                  <div *ngIf="!casesLoading && cases.length === 0" class="text-center py-5">
                    <i class="material-icons text-muted" style="font-size: 48px;">folder_open</i>
                    <p class="text-muted mt-2">No cases found for this client</p>
                  </div>

                  <mat-accordion *ngIf="!casesLoading && cases.length > 0">
                    <mat-expansion-panel *ngFor="let caseItem of cases">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <div class="d-flex align-items-center justify-content-between w-100">
                            <span>
                              <b>{{ caseItem.caseType?.name || '-' }}</b>,
                              {{ caseItem.district?.name || '-' }},
                              {{ caseItem.courtType?.name || '-' }},
                              <b> {{ caseItem.caseNumber || '-' }}/{{ caseItem.year || '-' }},
                                {{ caseItem.oppositeParty || '-' }} ({{ caseItem.oppositePartyRole || '-' }})
                              </b>
                              Filing: {{ caseItem.filingDate ? (caseItem.filingDate | date:'dd-MMM-yyyy') : '-' }}
                              Status: <b>{{ caseItem.status || '-' }}</b>
                              Judge: <b>{{ caseItem.judge || '-' }}</b>
                              Opp. Advocate: <b>{{ caseItem.oppositePartyAdvocate || '-' }}</b>
                            </span>
                            <div class="d-flex justify-content-end align-items-center ms-auto">
                              <i class="material-icons text-danger me-2" style="cursor: pointer;"
                                (click)="deleteCase(caseItem.id); $event.stopPropagation()">delete</i>
                              <i class="material-icons text-warning me-2" style="cursor: pointer;"
                                (click)="editCase(caseItem.id); $event.stopPropagation()">edit</i>
                              <i class="material-icons text-primary" style="cursor: pointer;"
                                (click)="openCaseAttachmentsModal(caseItem.attachments, caseItem); $event.stopPropagation()">folder</i>
                            </div>
                          </div>
                        </mat-panel-title>
                      </mat-expansion-panel-header>

                      <!-- Diaries Table -->
                      <div class="mt-3">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                          <h6 class="text-primary mb-0">Diaries</h6>
                          <button mat-raised-button type="button" class="btn btn-success btn-sm"
                            (click)="addNewDiary(caseItem.id)">
                            <i class="material-icons">add</i> Add Diary
                          </button>
                        </div>
                        <div *ngIf="!caseDiaries[caseItem.id] || caseDiaries[caseItem.id].length === 0"
                          class="text-center py-3">
                          <p class="text-muted">No diaries found for this case</p>
                        </div>
                        <div *ngIf="caseDiaries[caseItem.id] && caseDiaries[caseItem.id].length > 0"
                          class="table-responsive">
                          <table class="table table-hover table-striped">
                            <thead class="text-primary">
                              <tr>
                                <th>S.No</th>
                                <th>Diary</th>
                                <th>Date</th>
                                <th>Status</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let diary of caseDiaries[caseItem.id]; let i = index">
                                <td>{{ caseDiariesTotalItems[caseItem.id] - ((caseDiariesCurrentPage[caseItem.id] || 0)
                                  * (caseDiariesPageSize[caseItem.id] || 5)) - i }}</td>
                                <td>{{ diary.notes || '-' }}</td>
                                <td>{{ diary.hearingDate ? (diary.hearingDate | date:'EEE, dd-MMM-yyyy') : '-' }}</td>
                                <td>{{ diary.status }}</td>
                                <td>
                                  <i class="material-icons text-danger me-2" style="cursor: pointer;"
                                    (click)="deleteDiary(diary.id)">delete</i>
                                  <i class="material-icons text-warning me-2" style="cursor: pointer;"
                                    (click)="editDiary(diary.id)">edit</i>
                                  <i class="material-icons text-primary" style="cursor: pointer;"
                                    (click)="openDiaryAttachmentsModal(diary.attachments, diary)">folder</i>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <mat-paginator
                            *ngIf="caseDiariesTotalItems[caseItem.id] > (caseDiariesPageSize[caseItem.id] || 5)"
                            [length]="caseDiariesTotalItems[caseItem.id]"
                            [pageSize]="caseDiariesPageSize[caseItem.id] || 5" [pageSizeOptions]="[5, 10, 25, 50]"
                            (page)="onCaseDiaryPageChange(caseItem.id, $event)">
                          </mat-paginator>
                        </div>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>

                  <mat-paginator *ngIf="!casesLoading && cases.length > 0" [length]="casesTotalItems"
                    [pageSize]="casesPageSize" [pageSizeOptions]="[5, 10, 25, 50]" (page)="onCasesPageChange($event)">
                  </mat-paginator>
                </div>
              </mat-tab>

              <!-- Attachments Tab -->
              <mat-tab label="Attachments">
                <div class="mt-3">
                  <app-attachments-modal [attachments]="client?.attachments || []" [clientId]="clientId"
                    [attachmentType]="'Client'" (attachmentsUpdated)="loadClientDetails()">
                  </app-attachments-modal>
                </div>
              </mat-tab>

              <!-- Expenses Tab -->
              <mat-tab label="Expenses">
                <div class="mt-3">
                  <!-- Add New Expense Button -->
                  <div class="d-flex justify-content-end mb-3">
                    <button mat-raised-button type="button" class="btn btn-success" (click)="addNewExpense()">
                      <i class="material-icons">add</i> Add New Expense
                    </button>
                  </div>

                  <div *ngIf="expensesLoading" class="text-center py-3">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading expenses...</span>
                    </div>
                  </div>

                  <div *ngIf="!expensesLoading && expenses.length === 0" class="text-center py-5">
                    <i class="material-icons text-muted" style="font-size: 48px;">receipt</i>
                    <p class="text-muted mt-2">No expenses found for this client</p>
                  </div>

                  <div *ngIf="!expensesLoading && expenses.length > 0" class="table-responsive">
                    <table class="table table-hover table-striped">
                      <thead class="text-primary">
                        <tr>
                          <th>S.No</th>
                          <th>Case</th>
                          <th>Diary</th>
                          <th>Amount</th>
                          <th>Description</th>
                          <th>Date</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let expense of expenses; let i = index">
                          <td>{{ expensesTotalItems - (expensesCurrentPage * expensesPageSize) - i }}</td>
                          <td>{{ expense.case?.caseNumber || '-' }}/{{ expense.case?.year || '-' }}</td>
                          <td>{{ expense.diary?.hearingDate ? (expense.diary?.hearingDate | date:'EEE, dd-MMM-yyyy') : '-' }}
                          </td>
                          <td>{{ expense.amount ? (expense.amount | currency:'PKR':'symbol':'1.0-0')?.replace('PKR', 'PKR ') : '-' }}</td>
                          <td>{{ expense.description || '-' }}</td>
                          <td>{{ expense.expenseDate ? (expense.expenseDate | date:'EEE, dd-MMM-yyyy') : '-' }}</td>
                          <td>
                            <i class="material-icons text-danger me-2" style="cursor: pointer;"
                              (click)="deleteExpense(expense.id)">delete</i>
                            <i class="material-icons text-warning me-2" style="cursor: pointer;"
                              (click)="editExpense(expense.id)">edit</i>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <mat-paginator [length]="expensesTotalItems" [pageSize]="expensesPageSize"
                      [pageSizeOptions]="[5, 10, 25, 50]" (page)="onExpensesPageChange($event)">
                    </mat-paginator>
                  </div>
                </div>
              </mat-tab>

              <!-- Transactions Tab -->
              <mat-tab label="Transactions">
                <div class="mt-3">
                  <!-- Add New Transaction Button -->
                  <div class="d-flex justify-content-end mb-3">
                    <button mat-raised-button type="button" class="btn btn-success" (click)="addNewTransaction()">
                      <i class="material-icons">add</i> Add New Transaction
                    </button>
                  </div>

                  <div *ngIf="transactionsLoading" class="text-center py-3">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading transactions...</span>
                    </div>
                  </div>

                  <div *ngIf="!transactionsLoading && transactions.length === 0" class="text-center py-5">
                    <i class="material-icons text-muted" style="font-size: 48px;">account_balance_wallet</i>
                    <p class="text-muted mt-2">No transactions found for this client</p>
                  </div>

                  <div *ngIf="!transactionsLoading && transactions.length > 0" class="table-responsive">
                    <table class="table table-hover table-striped">
                      <thead class="text-primary">
                        <tr>
                          <th>S.No</th>
                          <th>Case</th>
                          <th>Diary</th>
                          <th>Amount</th>
                          <th>Transaction Date</th>
                          <th>Type</th>
                          <th>Notes</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let transaction of transactions; let i = index">
                          <td>{{ transactionsTotalItems - (transactionsCurrentPage * transactionsPageSize) - i }}</td>
                          <td>{{ transaction.case?.caseNumber || '-' }}/{{ transaction.case?.year || '-' }}</td>
                          <td>{{ transaction.diary?.hearingDate ? (transaction.diary?.hearingDate | date:'EEE, dd-MMM-yyyy') :
                            '-' }}</td>
                          <td>{{ transaction.amount ? (transaction.amount | currency:'PKR':'symbol':'1.0-0')?.replace('PKR', 'PKR ') : '-' }}</td>
                          <td>{{ transaction.transactionDate ? (transaction.transactionDate | date:'EEE, dd-MMM-yyyy') : '-' }}
                          </td>
                          <td>{{ transaction.transactionType || '-' }}</td>
                          <td>{{ transaction.notes || '-' }}</td>
                          <td>
                            <i class="material-icons text-danger me-2" style="cursor: pointer;"
                              (click)="deleteTransaction(transaction.id)">delete</i>
                            <i class="material-icons text-warning me-2" style="cursor: pointer;"
                              (click)="editTransaction(transaction.id)">edit</i>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <mat-paginator [length]="transactionsTotalItems" [pageSize]="transactionsPageSize"
                      [pageSizeOptions]="[5, 10, 25, 50]" (page)="onTransactionsPageChange($event)">
                    </mat-paginator>
                  </div>
                </div>
              </mat-tab>

            </mat-tab-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>